import { combineReducers } from "redux";
import account from "./account";

const index = combineReducers({
  account: account,
});

export default index;
